// Объект для наших блоков
window.Block = window.Block ? window.Block : {};

// Объект для наших импортов блоков
window.ImportBlock = window.ImportBlock ? window.ImportBlock : {};

// Объект для промисов загрузки блока
window.Loading = window.Loading ? window.Loading : {};

// Объект для бутстрапа
window.bootstrap ? null : window.bootstrap = {};
